var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg701711721731741751761762771781Dn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 45,
    viewBox: "0 0 55 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    fillRule: "evenodd",
    transform: "translate(0 -2)",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55,
    height: 55,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#C9C9C9",
    strokeWidth: 1.4,
    d: "M6.06 29.503L45.192 29.503M11.689 39.708L50.821 39.708M4.561 24.401L43.519 24.401M9.762 34.606L48.72 34.606M6.06 9.093L45.192 9.093M11.689 19.298L50.821 19.298M4.561 3.99L43.519 3.99M10.29 14.16L49.248 14.16M4.561 45.097L43.519 45.097"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg701711721731741751761762771781Dn);
export default __webpack_public_path__ + "static/media/701_711_721_731_741_751_761_762_771_781dn.2c568156c42cf11a3fac801f65997ef6.svg";
export { ForwardRef as ReactComponent };